import styled from "styled-components";
import { Card as MuiCard, CardActions, Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";

export const StyledCard = styled(MuiCard)`
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  box-sizing: border-box;
  background-color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  font-family: 'Inter', sans-serif;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
`;

export const TruncatedDescription = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors.textPrimary};
  line-height: 1.2;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
  flex-grow: 1;
`;

export const Footer = styled.div`
  font-size: 10px;
  font-weight: bold;
  margin-top: auto;
`;

export const Actions = styled(CardActions)`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 0;
`;

export const SemiBoldTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: ${(props) => props.theme.colors.textPrimary};
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
`;

export const AgentTypeChip = styled.div`
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  min-width: 65px;

  color: ${(props) => props.theme.colors.darkGray};
  border-radius: 100px;
  font-size: ${(props) => props.theme.fontSize.xs};
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: capitalize;

    &.langchain {
      background-color: ${(props) => props.theme.colors.lightAquamarina};
    }

`;

// Personalized chips for status and category
export const StatusChip = styled.div`
  background: ${({ status }) =>
    status === 'Draft' ? '#436089' : '#A7F3D0'};
  color: ${({ status }) =>
    status === 'Draft' ? '#fff' : '#047857'};
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  margin-right: 6px;
`;

export const CategoryChip = styled.div`
  background: #F3F4F6;
  color: #222;
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  margin-right: 6px;
`;

// Header layout
export const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;

export const CardHeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const CardHeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-left: 24px;
`;

// Footer layout
export const CardFooterInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 10px;
  font-weight: 400;
  justify-content: flex-start;
  margin-top: 30px;
`;

export const CardFooterLabel = styled.span`
  font-weight: 700;
  margin-right: 4px;
  font-size: 10px;
`;

export const MoreIconButton = styled(IconButton)`
  width: 28px;
  height: 28px;
  border: 1.5px solid #D1D5DB;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin-left: 0;
  svg {
    color: #1E293B;
    font-size: 18px;
  }
`;

// Custom layout and button styles for AgentCard
export const TitleAndChips = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;

export const ChipsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  margin-top: 2px;
  margin-bottom: 4px;
`;

export const EditButton = styled.button`
  width: 52px;
  height: 28px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  background: #E5E5E5;
  color: #222;
  box-shadow: none;
  border: none;
  cursor: pointer;
`;

export const ChatButton = styled.button`
  width: 64px;
  height: 28px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  background: #2563eb;
  color: #fff;
  box-shadow: none;
  border: none;
  cursor: pointer;
`;